<template>
	<it-link v-if="canLink" :to="href" v-preview="previewKey(srcType, srcId, srcSubType)">
		<slot></slot>
	</it-link>
	<span v-else><slot></slot></span>
</template>

<script setup lang="ts">
import {computed, ref, watchEffect} from "vue";
import {injectEnv} from "../Environment";
import {previewKey} from "./Preview";
import ItLink from "@/router/ItLink.vue";

const props = defineProps<{
	srcType: number,
	srcId: string | number,
	srcSubType?: number,
	/** Fallback URL if the system cannot resolve srcType/Id combo */
	fallback?: string
}>();
const env = injectEnv();

const canLink = computed<boolean>(() => !!props.srcId || props.fallback != null);

const href = ref<string|null>(null);

watchEffect(async () => {
	let url = await env.urlTo(props.srcType, props.srcId, props.srcSubType);
	if (url == null) url = props.fallback;
	href.value = url;
});

</script>

<style>
</style>